const styles = {
  page: {
    minHeight: "100vh",
    p: { xs: "28px 16px 56px", md: "28px 24px 72px" },
    backgroundColor: "#FAFAF6",
  },
  inner: {
    maxWidth: "880px",
    mx: "auto",
  },
  logoWrap: {
    display: "flex",
    justifyContent: "center",
    mb: "24px",
  },
  logoImg: {
    height: 36,
    width: "auto",
    display: "block",
  },
  freePlanWrap: {
    textAlign: "center",
    py: 3,
  },
  freePlanLink: {
    fontSize: "13px",
    fontWeight: 700,
    color: "#8084FF",
    textDecoration: "none",
    "&:hover": { textDecoration: "underline" },
  },
  footer: {
    textAlign: "center",
    mt: "32px",
    fontSize: "13px",
    lineHeight: 1.6,
    color: "#776B5D",
  },
  footerLink: {
    color: "#014638",
    fontWeight: 600,
    textDecoration: "none",
  },
  overlay: {
    position: "fixed",
    inset: 0,
    zIndex: 1400,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 2,
    backdropFilter: "blur(6px)",
    backgroundColor: "rgba(16, 24, 40, 0.55)",
  },
  overlayCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 2,
    backgroundColor: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: "20px",
    px: 5,
    py: 4,
  },
  overlayTitle: {
    color: "#fff",
    fontWeight: 600,
    fontSize: "1rem",
    letterSpacing: "0.01em",
  },
  overlaySub: {
    color: "rgba(255,255,255,0.5)",
    fontSize: "0.85rem",
  },
  dialogClose: {
    display: "flex",
    justifyContent: "flex-end",
    pt: 2,
  },
};

export default styles;
